import Api from "../../../services/Api";

//start date and end date should be in ISO format
function fetchOcppMessages(serialNumber, startDate, endDate, page, pageSize, filters) {
  const params = {
    start: startDate,
    end: endDate,
    page,
    pageSize,
    ...filters,
  };

  return Api.get(`/service/iqevse-csms/charger/v1/ocpp-messages/${serialNumber}`, params, {
    paramsSerializer: {
      serialize: params => {
        const query = new URLSearchParams();

        Object.entries(params).forEach(([key, value]) => {
          if (Array.isArray(value)) {
            value.forEach(v => query.append(key, v));
          } else {
            query.append(key, value);
          }
        });

        return query.toString();
      },
    },
  });
}

export { fetchOcppMessages };
